import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=a2a9cd52&scoped=true&"
import script from "./CustomDrawer.vue?vue&type=script&lang=js&"
export * from "./CustomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=a2a9cd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a9cd52",
  null
  
)

export default component.exports